import React, { useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Send, CheckCircle2 } from "lucide-react";

export function TelegramConnect({ connected }) {
  const [busy, setBusy] = useState(false);
  const connect = async () => {
    const w = window.open("about:blank", "_blank");
    setBusy(true);
    try {
      const { data } = await client.get("/tm/telegram-link");
      if (w) w.location.href = data.url; else window.location.href = data.url;
      toast.success("Telegram me START dabayein, phir yahan refresh karein");
    }
    catch (e) { if (w) w.close(); toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="surface p-5 flex flex-wrap items-center gap-4" data-testid="tm-telegram-card">
      <div className="w-10 h-10 flex items-center justify-center bg-[#2AABEE] text-white"><Send size={18} /></div>
      <div className="flex-1 min-w-[200px]">
        <div className="text-white font-head">Telegram Lead Alerts</div>
        <div className="text-xs text-slate-400">{connected ? "Connected — nayi assigned leads Telegram par turant aayengi." : "Connect karein taaki assigned leads ki details Telegram par turant milein."}</div>
      </div>
      {connected
        ? <span data-testid="tm-telegram-connected" className="flex items-center gap-1.5 text-sm text-bull"><CheckCircle2 size={16} />Connected</span>
        : <button data-testid="tm-telegram-connect" disabled={busy} onClick={connect} className="btn-gold px-4 py-2 text-xs disabled:opacity-60">Connect Telegram</button>}
    </div>
  );
}
